module.exports = __webpack_public_path__ + "static/media/clipboard.291304d1.png";